/* 🤖 this file was generated by script */
export const wiconBuilding05 = {
  name: 'building_05',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 11h4.8c1.12 0 1.68 0 2.1.22.38.19.69.5.88.87.22.43.22.99.22 2.11V21m-8 0V6.2c0-1.12 0-1.68-.22-2.1a2 2 0 00-.87-.88C11.48 3 10.92 3 9.8 3H6.2c-1.12 0-1.68 0-2.1.22a2 2 0 00-.88.87C3 4.52 3 5.08 3 6.2V21m19 0H2M6.5 7h3m-3 4h3m-3 4h3"/></svg>`,
};
